exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.download {\n  margin-top: 35px;\n}\n.download h1 {\n    font-size: 28px;\n}\n.download h3 {\n    font-size: 20px;\n}\n", "", {"version":3,"sources":["/Users/Razvan/Documents/projects/archii/website-new/apps/account/Download.vue"],"names":[],"mappings":";AAAA;EACE,iBAAiB;CAAE;AACnB;IACE,gBAAgB;CAAE;AACpB;IACE,gBAAgB;CAAE","file":"Download.vue","sourcesContent":[".download {\n  margin-top: 35px; }\n  .download h1 {\n    font-size: 28px; }\n  .download h3 {\n    font-size: 20px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a84fc29","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./apps/account/Download.vue
// module id = 487
// module chunks = 0